{
  "title": "الأمانة {{number}}",
  "backToList": "الأمانات",
  "sections": {
    "summary": "ملخص الأمانة",
    "employees": "الموظفون والأوقات",
    "messages": "رسائل واتساب",
    "prints": "الطباعة"
  },
  "language": "لغة المودع",
  "languageName": {
    "ar": "العربية",
    "en": "الإنجليزية"
  },
  "cancelReason": "سبب الإلغاء",
  "created": "تم الإنشاء بواسطة",
  "cancelledBy": "موظف الإلغاء",
  "documentPhoto": "صورة الوثيقة",
  "notDelivered": "لم تسلم بعد",
  "noMessages": "لا توجد رسائل لهذه الأمانة",
  "noPrints": "لم يطبع الوصل بعد",
  "print": {
    "first": "طباعة",
    "reprint": "إعادة طباعة",
    "PRINTED": "تمت",
    "FAILED": "فشلت"
  },
  "template": {
    "deposit_created_depositor": "إشعار الإيداع للمودع",
    "deposit_created_recipient": "إشعار الإيداع للمستلم",
    "deposit_delivered": "إشعار التسليم",
    "deposit_returned": "إشعار الاسترداد"
  },
  "noHistory": "لا توجد تعديلات",
  "oldValue": "القيمة السابقة",
  "newValue": "القيمة الجديدة",
  "editField": {
    "amount": "المبلغ",
    "currency": "العملة",
    "location": "مكان الأمانة",
    "notes": "ملاحظات",
    "depositor.fullName": "المودع: الاسم الكامل",
    "depositor.phone": "المودع: الهاتف",
    "depositor.documentType": "المودع: نوع الوثيقة",
    "depositor.documentNumber": "المودع: رقم الوثيقة",
    "depositor.documentCountry": "المودع: دولة الإصدار",
    "intendedRecipient.fullName": "المستلم المقصود: الاسم الكامل",
    "intendedRecipient.phone": "المستلم المقصود: الهاتف",
    "actualRecipient.fullName": "المستلم الفعلي: الاسم الكامل",
    "actualRecipient.phone": "المستلم الفعلي: الهاتف",
    "actualRecipient.documentType": "المستلم الفعلي: نوع الوثيقة",
    "actualRecipient.documentNumber": "المستلم الفعلي: رقم الوثيقة",
    "actualRecipient.documentCountry": "المستلم الفعلي: دولة الإصدار"
  },
  "referralStatus": {
    "PENDING": "بانتظار مراجعة المشرف",
    "APPROVED": "موافقة",
    "REJECTED": "رفض"
  },
  "failureGeneric": "تعذر إرسال الرسالة. حاول مرة أخرى في وقت لاحق.",
  "failureCodes": {
    "1": "الخدمة غير متاحة في الوقت الحالي لدى مزود واتساب",
    "2": "الخدمة غير متاحة في الوقت الحالي لدى مزود واتساب",
    "4": "تم تجاوز الحد المسموح من الطلبات، حاول في وقت لاحق",
    "100": "بيانات الرسالة غير صحيحة",
    "130429": "تم تجاوز الحد المسموح من الرسائل، حاول في وقت لاحق",
    "131000": "تعذر على مزود واتساب تنفيذ الطلب، حاول مرة أخرى",
    "131026": "تعذر تسليم الرسالة، الرقم غير مسجل في واتساب أو لا يقبل الرسائل",
    "131030": "رقم المستلم غير مسموح له باستلام الرسائل",
    "131042": "مشكلة في الدفع لدى حساب واتساب للأعمال",
    "131047": "انتهت مهلة المحادثة، يلزم إرسال قالب جديد",
    "131048": "تم تقييد الإرسال بسبب كثرة الرسائل المرفوضة",
    "131049": "لم يتم تسليم الرسالة للحفاظ على جودة التفاعل مع المستلم",
    "131053": "فشل رفع صورة الرسالة، تحقق من الصورة",
    "131056": "تم تجاوز الحد المسموح من الرسائل لهذا المستلم، حاول في وقت لاحق",
    "132000": "عدد متغيرات القالب لا يطابق القالب المعتمد",
    "132001": "القالب غير موجود أو غير معتمد بهذه اللغة",
    "132005": "نص القالب بعد الترجمة طويل للغاية",
    "132012": "قيم متغيرات القالب غير صحيحة",
    "190": "انتهت صلاحية ربط حساب واتساب، يلزم تجديده"
  },
  "phoneRefusedByCustomers": "رفض نظام العملاء هذا الرقم، عدّل رقم الهاتف"
}
